import { createContext, useState, useEffect } from 'react';
import i18n, { I18N_MANUAL_STORAGE_KEY, I18N_STORAGE_KEY } from '../../i18n/index';

const SPANISH_SPEAKING_COUNTRIES = new Set([
  'ar', 'bo', 'cl', 'co', 'cr', 'cu', 'do', 'ec', 'es', 'gq',
  'gt', 'hn', 'mx', 'ni', 'pa', 'pe', 'pr', 'py', 'sv', 'uy', 've',
])

function getLanguageFromCountry(country) {
  if (country === 'br') return 'ptBR'
  if (SPANISH_SPEAKING_COUNTRIES.has(country)) return 'es'
  return 'en'
}

export const IntlContext = createContext()

// eslint-disable-next-line react/prop-types
export const IntlContextProvider = ({children}) => {
    
  const [country, setCountry] = useState(null)

  useEffect(() => {
    let isMounted = true

    async function getUserCountry() {
      try {
        const response = await fetch('https://get.geojs.io/v1/ip/country.json')
        const data = await response.json()
        if (isMounted) {
          setCountry(data.country?.toLowerCase() ?? 'br')
        }
      } catch {
        if (isMounted) {
          setCountry('br')
        }
      }
    }

    getUserCountry()

    return () => {
      isMounted = false
    }
  }, [])

  useEffect(() => {
    if (country === null) return
    if (localStorage.getItem(I18N_MANUAL_STORAGE_KEY) === 'true') return

    const language = getLanguageFromCountry(country)
    if (i18n.resolvedLanguage === language) return

    i18n.changeLanguage(language)
    localStorage.setItem(I18N_STORAGE_KEY, language)
  }, [country])
  

  const value  = {country}

  return( 
    <IntlContext.Provider value={value}>
      {children}
    </IntlContext.Provider>
  )
}
